/*
 * @@Copyright (c): Knowdee All rights reserved.
 * @Description: 对话交互接口
 * @Author: wangwz@knowdee.com
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2022-05-15 20:37:46
 * @LastEditTime: 2022-11-18 19:36:42
 * @FilePath: /client-h5-v2/src/apis/dialog/chat.ts
 */
// 导入axios实例
import httpRequest from '@/request/index'
import { DialogChatParam } from '@/apis/types'
import { apiGetLocalfiles } from '@/apis/config/applicationPropterty'
import store from '@/store/index'

// 获取用户信息
export function apiGetDialogChat (param: DialogChatParam) {
  if (window.botV2GlobalProperties.NODE_ENV === 'development') {
    // 本地模拟模版
    store.commit('dialog/CLEAR_LOADING')
    return apiGetLocalfiles(`/${window.botV2GlobalProperties.BASE_PATH}/json/answer/${window.botV2GlobalProperties.DIALOG_TEMPLATE_FILE_NAME}.json`)
  } else if (window.location.href.includes('webview')) {
    // webview模式
    return httpRequest({
      url: `/${store.getters['global/channel']}/api/v1/h5WebView/chat`,
      method: 'post',
      data: param
    })
  } else {
    // 普通web(pc、mobile)模式
    return httpRequest({
      url: '/api/v1/dialog/chat',
      method: 'post',
      data: param
    })
  }
}
